import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { FiCompass, FiSearch, FiHeart, FiMessageCircle, FiUser } from 'react-icons/fi';
import { FaCompass, FaSearch, FaHeart, FaCommentDots, FaUser } from 'react-icons/fa';

const tabs = [
  { path: '/discover', label: 'Discover', icon: FiCompass, activeIcon: FaCompass },
  { path: '/explore', label: 'Explore', icon: FiSearch, activeIcon: FaSearch },
  { path: '/likes', label: 'Likes', icon: FiHeart, activeIcon: FaHeart },
  { path: '/messages', label: 'Messages', icon: FiMessageCircle, activeIcon: FaCommentDots },
  { path: '/profile', label: 'Profile', icon: FiUser, activeIcon: FaUser },
];

const BottomNav = () => {
  const location = useLocation();
  const hidden = ['/chat', '/onboarding', '/login', '/signup', '/profile-setup'].some(p => location.pathname.startsWith(p));

  if (hidden) return null;

  return (
    <nav style={{
      position: 'fixed', bottom: 0, left: '50%', transform: 'translateX(-50%)',
      width: '100%', maxWidth: 430, zIndex: 50,
      background: 'rgba(8,8,12,0.85)', backdropFilter: 'blur(24px)', WebkitBackdropFilter: 'blur(24px)',
      borderTop: '1px solid rgba(255,255,255,0.04)',
      paddingBottom: 'max(8px, env(safe-area-inset-bottom))',
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-around', padding: '6px 0 4px' }}>
        {tabs.map(tab => {
          const isActive = location.pathname === tab.path || location.pathname.startsWith(tab.path + '/');
          const Icon = isActive ? tab.activeIcon : tab.icon;
          return (
            <NavLink key={tab.path} to={tab.path} style={{
              display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2,
              padding: '4px 12px', textDecoration: 'none', position: 'relative',
              transition: 'all 0.2s ease',
            }}>
              <div style={{
                transition: 'all 0.2s ease',
                transform: isActive ? 'scale(1.1)' : 'scale(1)',
              }}>
                <Icon size={20} style={{ color: isActive ? '#FF3D71' : '#52525B', transition: 'color 0.2s' }} />
              </div>
              <span style={{
                fontSize: 10, fontWeight: isActive ? 600 : 400,
                color: isActive ? '#FF3D71' : '#52525B',
                transition: 'color 0.2s',
              }}>{tab.label}</span>
              {isActive && (
                <div style={{
                  position: 'absolute', top: -6, left: '50%', transform: 'translateX(-50%)',
                  width: 20, height: 3, borderRadius: 2,
                  background: 'linear-gradient(135deg, #FF3D71, #8B5CF6)',
                }} />
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
